export default "__VITE_ASSET__C9ZDs_$j__"